<template>
  <p class="tips-wrap">
    <span class="tips-login" @click.stop.prevent="toLogin">登录</span>
    <span>/</span>
    <router-link class="tips-register" to="/register">注册</router-link>
    <span>会员即可享受会员价</span>
  </p>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'Tip',
  data () {
    return {
    }
  },
  methods: {
    ...mapActions([
      'toLogin'
    ])
  }
}
</script>

<style lang="scss" scoped>
  @import '../assets/css/mixin';
  .tips-wrap {
    display: flex;
    font-size: 14px;
    margin-top: 5px;
    justify-content: center;
    width: 100%;
    * {
      color: #606266;
    }
    .tips-login, .tips-register {
      flex: none;
    }
    .tips-login:hover, .tips-register:hover {
      text-decoration: underline;
      cursor: pointer;
    }
  }
  @media only screen and (max-width: 768px) {
    .tips-wrap {
      font-size: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Tip.vue